module.exports = {
          srcSet: __webpack_public_path__ + "f0c65c38.jpg"+" 700w"+","+__webpack_public_path__ + "3d448b8a.jpg"+" 1280w",
          images:[ {path: __webpack_public_path__ + "f0c65c38.jpg",width: 700,height: 525},{path: __webpack_public_path__ + "3d448b8a.jpg",width: 1280,height: 960}],
          src: __webpack_public_path__ + "f0c65c38.jpg",
          toString:function(){return __webpack_public_path__ + "f0c65c38.jpg"},
          
          width: 700,
          height: 525
        }